module.exports = __webpack_public_path__ + "static/media/email.86a69566.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email.png
// module id = 274
// module chunks = 0